export interface LineTypeTooltipLabels {
  lines: (count: number) => string;
  committed: (count: number) => string;
}

/**
 * Tooltip behind a dollars-by-type cell: how many lines of the type the order
 * holds and how many of them are committed (only committed lines carry dollars).
 */
export function lineTypeTooltip(
  count: number,
  committed: number,
  labels: LineTypeTooltipLabels,
): string {
  return `${labels.lines(count)}, ${labels.committed(committed)}`;
}
